module.exports = __webpack_public_path__ + "static/media/homescreen_icon.f0b633c8.svg";